module.exports = __webpack_public_path__ + "img/cases-brand-chinamobile-lazyload-22.2fc8bb9a.jpg";